var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z",
    fill: "#7269EF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_133_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.309 65.2117C129.078 64.1908 126.761 63.3031 123.961 62.5468C113.712 59.7586 102.915 60.1084 93.0421 63.3362C83.3951 66.4931 74.6249 72.4084 68.1174 80.8504C65.7803 83.8809 63.8252 87.0038 62.2424 90.1778C56.7868 101.128 55.5874 112.865 58.2442 123.656C60.9095 134.444 67.4206 144.281 77.3945 151.431C80.3012 153.518 83.4845 155.367 86.9157 156.93C94.9506 160.598 103.709 162.104 112.414 161.404C120.96 160.717 129.443 157.895 137.116 152.9C144.413 148.142 150.481 142.073 154.697 135.025C158.708 128.329 161.028 120.728 161.146 112.534C161.18 109.97 160.997 107.404 160.566 104.853C160.141 102.293 159.472 99.7285 158.549 97.155C157.971 95.5437 156.145 94.714 154.473 95.3001C152.801 95.8863 151.917 97.6693 152.495 99.2806C153.301 101.508 153.879 103.728 154.249 105.945C154.62 108.162 154.781 110.368 154.755 112.548C154.661 119.623 152.652 126.176 149.18 131.988C145.47 138.204 140.099 143.569 133.612 147.788C126.893 152.167 119.463 154.644 111.994 155.242C104.4 155.844 96.7502 154.529 89.7239 151.319C86.6247 149.903 83.7976 148.266 81.2503 146.441C72.5009 140.168 66.7951 131.567 64.4698 122.142C62.1444 112.716 63.2023 102.439 67.9994 92.8184C69.4226 89.9603 71.1539 87.186 73.216 84.5161C78.8812 77.1601 86.5511 72.0004 95.0016 69.2304C103.67 66.3916 113.163 66.0888 122.151 68.5314C124.866 69.273 127.1 70.154 129.301 71.1995L116.865 74.5977C115.156 75.0623 114.137 76.7726 114.598 78.4204C115.051 80.0701 116.8 81.0311 118.507 80.5582L138.319 75.1396C140.028 74.675 141.047 72.9646 140.586 71.3169C140.561 71.2098 140.52 71.115 140.488 71.0182L133.351 52.9631C132.723 51.3721 130.881 50.5897 129.221 51.2253C127.57 51.8588 126.734 53.6565 127.363 55.2557L131.309 65.2117Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_133_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(147 47) rotate(76.7106)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.9290bd5aed1761ecea1be14c8e6acdfd.svg";
export { ForwardRef as ReactComponent };